export const production = {
    envName: 'production',
    appName: 'AllTrace',
    debug: false,
    bypassAuth: false,
    clientIdentifier: "z00WpXQTcyMJGAKpMpZs9MdrhpFOQY0K9km4fv3h7mDnbSDa4VuhWYUDuUigA7Zy",
    api: 'https://{tenant}.alltrace.app/api/',
    url: 'https://m.alltrace.app/',
};
